// extracted by css-extract-rspack-plugin
export default {"seo":"Ay4pm","picture":"tyRFn","white-60":"oKAQo","white60":"oKAQo","white-80":"lUnz9","white80":"lUnz9"};